import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles({
  actionsContainer: { paddingLeft: 100 },
  cancelButton: { marginRight: 10 },
});

export default useStyles;
